const BudgetTemplate = () => import(/* webpackChunkName: "manager" */ './Index');

export default {
    routes: [
        {
            path: '/proj/budget_tplt',
            name: 'proj_budget_tplt',
            component: BudgetTemplate
        }
    ]
}
